import { render } from "./AddFooter.vue?vue&type=template&id=13648f00"
import script from "./AddFooter.vue?vue&type=script&lang=js"
export * from "./AddFooter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__